import axios from 'constants/axios';
import FileSaver from 'file-saver';

const FILENAME_REGEX = /filename="(.+)"/;

export const saveFile = (blob: Blob, fileName: string) => {
  if (
    /CriOS/i.test(navigator.userAgent) &&
    /iphone|ipod|ipad/i.test(navigator.userAgent)
  ) {
    const reader = new FileReader();
    reader.onloadend = () => {
      window.location.href = reader.result as string;
    };
    reader.readAsDataURL(blob);
  } else {
    FileSaver.saveAs(blob, fileName);
  }
};

export const fetchFile = (
  fileURL: string,
  successCallback?: () => void,
  errCallback?: (status?: number) => void,
  customFileType?: string,
  customFileName?: string
) => {
  axios({
    url: fileURL,
    method: 'GET',
    responseType: 'blob', // important
  }).then((response) => {
    if (response.status === 200 || response.status === 201) {
      const rawContentDisposition = response.headers['content-disposition'];
      const fileContentHeader =
        typeof rawContentDisposition === 'string'
          ? rawContentDisposition
          : undefined;
      const rawContentType = response.headers['content-type'];
      const mimetype =
        typeof rawContentType === 'string' ? rawContentType : undefined;
      const matches = fileContentHeader?.match(FILENAME_REGEX);
      const fileName = customFileName || (matches ? matches[1] : 'file');
      const blob = new Blob([response.data as unknown as BlobPart], {
        type: customFileType || mimetype,
      });
      /*

        Workaround for Chrome 80 on iOS13 and some other combos of Chrome and iOS

        Watch this https://github.com/eligrey/FileSaver.js/issues/467
        and million other issues
      */
      saveFile(blob, fileName);

      if (successCallback) {
        successCallback();
      }
    } else if (errCallback) {
      errCallback(response.status);
    }
  });
};
